<template>
  <div @click="active" class="page-tag" >
    <span>{{title}}</span>
    <i v-if="closeable" class="close-icon el-icon-circle-close" @click.stop="close"></i>
<!--    <img v-if="closeable" src="../../../assets/label-close.png" class="close-icon" @click.stop="close">-->
  </div>

</template>

<script>

  export default {
    name: "page-tag",
    props: {
      title: {type: String, require: true},
      name: {type: String, require: true},
      closeable: {type: Boolean, default: true},
    },
    data() {
      return {}
    },
    computed: {},
    watch: {},
    methods: {
      close() {
        this.$emit("close");
      },
      active() {
        this.$emit("active");
      }
    },
    mounted() {

    },

  }
</script>

<style lang="scss" scoped>
  .page-tag{
    //-webkit-box-shadow: #DFE1E3 0 2px 9px 0;
    //-moz-box-shadow: #DFE1E3 0 2px 9px 0;
    //box-shadow: #DFE1E3 0 2px 9px 0;
    display: inline-block;
    font-size: 12px;
  }
  .page-tag:hover .close-icon{
    display: inline-block;
    color: #A9AEBB;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/PageTagList/page-tag.vue